import { ManagementReportAccountingRepository } from '@domain/management-report-accounting/repositories/management-report-accounting.repository';
import { ManagementReportAccountingRepositoryService } from '../repositories/management-report-accounting.service';

export const ManagementReportAccountingProvider = [
  {
    provide: ManagementReportAccountingRepository,
    useClass: ManagementReportAccountingRepositoryService,
  },
];
